<nz-radio-group [(ngModel)]='check' (ngModelChange)='checkRadio()' class='flexRow'>
  <ng-container *ngFor='let item of data'>
    <label nz-radio-button [nzValue]="item['value']" [nzDisabled]="item['disabled']" class='radio-item'
           [ngStyle]='itemStyle'>
      <i class='radio-point' *ngIf="check == item['value'] && checkPoint"></i>
      {{ item['title'] }}
      <i nz-icon nzType='info-circle' nzTheme='outline' *ngIf="item['tpl']==true" style='color:#E01738' class='ml-sm' nz-tooltip  [nzTooltipTitle]="tooltipTpl" nzTooltipColor='#FFF'></i>
      <ng-template #tooltipTpl>
        <span style='color:#E01738;' class='text-xs'>岗位所属部门已冻结</span>
      </ng-template>
      <ng-container *ngIf="item['alt'] != undefined">
        <i
          [ngStyle]="item['alt']['style']"
          [nzTooltipVisible]='false'
          nz-tooltip
          [nzTooltipTitle]='tooltipTitleToggle'
          nzTooltipColor='#fff'
          nz-icon
          nzIconfont="{{ item['alt']['icon'] ? item['alt']['icon'] : 'icon_notice' }}"
          class='float-right mt-sm text-xs error-color'
        ></i>
        <ng-template #tooltipTitleToggle>
          <div class='text-gray1 p-xs'>{{ item['alt']['text'] }}</div>
        </ng-template>
      </ng-container>
    </label>
  </ng-container>
</nz-radio-group>
